import { schema } from 'normalizr';
import { participantLinkedEntities, participantSchema } from '../Participant';

export const PARTICIPATION_TAG_ENTITY_NAME = 'participationTags';
export const SESSION_ENTITY_NAME = 'sessions';
export const APPOINTMENT_ENTITY_NAME = 'appointments';
export const PARTICIPATION_ENTITY_NAME = 'participations';
export const MESSAGE_ENTITY_NAME = 'messages';

export const participationLinkedEntities = [
  PARTICIPATION_ENTITY_NAME,
  APPOINTMENT_ENTITY_NAME,
  SESSION_ENTITY_NAME,
  ...participantLinkedEntities,
];

export const messageLinkedEntities = [
  MESSAGE_ENTITY_NAME,
  PARTICIPATION_ENTITY_NAME,
];
export const appointmentLinkedEntities = [
  APPOINTMENT_ENTITY_NAME,
  SESSION_ENTITY_NAME,
  ...participantLinkedEntities,
];
export const sessionLinkedEntities = [
  SESSION_ENTITY_NAME,
  PARTICIPATION_ENTITY_NAME,
  PARTICIPATION_TAG_ENTITY_NAME,
  ...appointmentLinkedEntities,
  ...participantLinkedEntities,
];

const emptyAppointmentSchema = new schema.Entity(APPOINTMENT_ENTITY_NAME);

export const participationTagSchema = new schema.Entity(
  PARTICIPATION_TAG_ENTITY_NAME,
);

export const emptyMessageSchema = new schema.Entity(MESSAGE_ENTITY_NAME);

export const participationSchema = new schema.Entity(
  PARTICIPATION_ENTITY_NAME,
  {
    session: new schema.Entity(SESSION_ENTITY_NAME, {
      appointments: [emptyAppointmentSchema],
      availableAppointments: [emptyAppointmentSchema],
      bookedAppointments: [emptyAppointmentSchema],
    }),
    appointment: emptyAppointmentSchema,
    participant: participantSchema,
    messages: emptyMessageSchema,
  },
);

export const sessionSchema = new schema.Entity(SESSION_ENTITY_NAME, {
  appointments: [emptyAppointmentSchema],
  availableAppointments: [emptyAppointmentSchema],
  bookedAppointments: [emptyAppointmentSchema],
  participations: [
    new schema.Entity(PARTICIPATION_ENTITY_NAME, {
      appointment: emptyAppointmentSchema,
      participant: participantSchema,
    }),
  ],
  availableTags: [participationTagSchema],
});

export const appointmentSchema = new schema.Entity(APPOINTMENT_ENTITY_NAME, {
  session: sessionSchema,
  participation: participationSchema,
});

export const participationWithFullSessionSchema = new schema.Entity(
  PARTICIPATION_ENTITY_NAME,
  {
    session: sessionSchema,
    appointment: emptyAppointmentSchema,
    participant: participantSchema,
  },
);

export const messageSchema = new schema.Entity(MESSAGE_ENTITY_NAME, {
  participation: participationSchema,
});
